



































import { Prop, Component, Vue } from 'vue-property-decorator'
import { Referral } from '@/api/model/referral'
import { ReferralStatus } from '@/api/types'
import { isAllowedUserForReferral } from '@/helpers/security'

@Component
export default class ColumnStatus extends Vue {
    @Prop({ required: true }) referral!: Referral

    routeToDetail(referral: Referral) {
        if (!isAllowedUserForReferral(this.$currentUser, referral) && this.$currentUser.betaOptInEnabled) {
            return {
                name: 'one_contact_detail',
                params: {
                    contactId: referral.contact.id,
                    toOne: this.$currentUser.betaOptInEnabled,
                },
            }
        }

        return {
            name: 'tasks_detail',
            params: {
                referralId: referral.id,
                contactId: referral.contact.id,
                toOne: this.$currentUser.betaOptInEnabled,
            },
        }
    }

    colorForStatus(status: string, opacity: number = 1): string {
        switch (status) {
            case ReferralStatus.OPEN: return `rgba(96, 96, 96, ${opacity})`
            case ReferralStatus.NEW: return `rgba(19, 210, 197, ${opacity})`
            case ReferralStatus.UNREACHABLE: return `rgba(235, 89, 140, ${opacity})`
            case ReferralStatus.PENDING: return `rgba(247, 131, 35, ${opacity})`
            case ReferralStatus.APPOINTMENT: return `rgba(66, 153, 225, ${opacity})`
            case ReferralStatus.PROPOSAL: return `rgba(145, 105, 226, ${opacity})`
            case ReferralStatus.ON_HOLD: return `rgba(231, 220, 30, ${opacity})`
            case ReferralStatus.SUCCESSFUL: return `rgba(0, 163, 137, ${opacity})`
            case ReferralStatus.CLOSED: return `rgba(222, 64, 119, ${opacity})`
            case ReferralStatus.PROCESSED: return `rgba(96, 96, 96, ${opacity})`
            default: return `rgba(169, 50, 38, ${opacity})`
        }
    }

    generateReferralStatusClasses(status: string) {
        const classes = {
            'new': 'active',
            'appointment': 'active',
            'proposal': 'active',
            'on-hold': 'pending',
            'pending': 'pending',
            'unreachable': 'hold',
            'successful': 'closed',
            'processed': 'closed',
            'closed': 'closed',
        }

        return classes[status]
    }
}
